import React from 'react';
import { Pressable } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { colors, radius, useAppTheme } from '@/theme';
import { ScaledSheet } from '@/theme/responsive';

interface Props {
  checked: boolean;
  onToggle: () => void;
  accessibilityLabel: string;
}

export function Checkbox({ checked, onToggle, accessibilityLabel }: Props) {
  const { colors } = useAppTheme();

  return (
    <Pressable
      accessibilityRole="checkbox"
      accessibilityState={{ checked }}
      // react-native-web does not turn accessibilityState into aria-checked; a checkbox must state its value.
      aria-checked={checked}
      accessibilityLabel={accessibilityLabel}
      onPress={onToggle}
      hitSlop={8}
      style={[
        styles.box,
        { borderColor: colors.borderStrong, backgroundColor: colors.surface },
        checked && { backgroundColor: colors.accentFill, borderColor: colors.accent },
      ]}>
      {checked && <Ionicons name="checkmark" size={14} color={colors.textOnAccent} />}
    </Pressable>
  );
}

const styles = ScaledSheet.create({
  box: {
    // 24 is the smallest touch target WCAG 2.2 accepts.
    width: 24,
    height: 24,
    borderRadius: radius.xs,
    borderWidth: 1.5,
    borderColor: colors.borderStrong,
    alignItems: 'center',
    justifyContent: 'center',
  },
  boxChecked: { backgroundColor: colors.accentFill, borderColor: colors.accent },
});
